import React from 'react';
import { useSelector } from 'react-redux';

import { FeedbackRecognitionRequestTypes, FeedbackRecognitionType } from 'Shared/constants/types';
import { getUserById } from 'Shared/selectors/workspace';
import { getFirstName } from 'Shared/helpers';

import './NotificationAndViewedBar.scss';

type Props = {
  feedback: FeedbackRecognitionType;
  currentUserId: number;
};

export default function NotificationAndViewedBar({ feedback, currentUserId }: Props) {
  const { recipientViewed, creatorId, receiverId, requestType, viewerIds, workspaceName } = feedback;
  const receiverFirstName = useSelector(getUserById(receiverId))?.firstName || getFirstName(workspaceName);

  const requestIsKudos = requestType === FeedbackRecognitionRequestTypes.recognition;
  const userIsCreator = currentUserId === creatorId;
  const userViewed = viewerIds.includes(currentUserId);

  if (userIsCreator && recipientViewed)
    return <div className="feedback-item-seen-bar">{`Seen by ${receiverFirstName}`}</div>;
  if (userIsCreator && !recipientViewed)
    return <div className="feedback-item-seen-bar">{`${receiverFirstName} hasn't seen this yet`}</div>;
  if (!userIsCreator && !userViewed)
    return <div className="feedback-item-notification-bar">{requestIsKudos ? 'New Kudos' : 'New Feedback'}</div>;
  return null;
}
